
import { VAppBar } from "vuetify/lib";

export default VAppBar.extend({});
